export default __webpack_public_path__ + "static/media/nphl_header_4.ee6f3a0b.jpg";